import { render, staticRenderFns } from "./WidgetsRender.vue?vue&type=template&id=7ed23a68&scoped=true"
import script from "./WidgetsRender.vue?vue&type=script&lang=js"
export * from "./WidgetsRender.vue?vue&type=script&lang=js"
import style0 from "./WidgetsRender.vue?vue&type=style&index=0&id=7ed23a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed23a68",
  null
  
)

export default component.exports